import __vue_component__ from './IconWrapper.vue.js';

var MentionIcon = {
  name: 'MentionIcon',
  props: {
    size: {
      type: String
    },
    primaryColor: {
      type: String
    },
    secondaryColor: {
      type: String
    }
  },

  render(h) {
    // eslint-disable-next-line max-len
    return h(__vue_component__, {
      props: { ...this.$props
      },
      domProps: {
        innerHTML: '<svg viewBox="0 0 24 24"><g fill="currentColor" fill-rule="evenodd"><path d="M11.94 12H5.008A2.006 2.006 0 0 0 3 14v4.446c0 2.233 5.16 3.002 8.713 2.306A6.475 6.475 0 0 1 10.13 16.5c0-1.746.689-3.332 1.81-4.5z"/><path d="M21.153 13.123c.795 1.036 1.042 2.316.69 3.603-.34 1.254-.95 2.077-1.814 2.446-1.139.486-2.2-.052-2.315-.114a2.21 2.21 0 0 1-.575-.482c-.448.328-.94.52-1.417.52a1.74 1.74 0 0 1-.832-.206 1.837 1.837 0 0 1-.883-1.12c-.21-.715-.08-1.574.357-2.358.718-1.288 2.168-1.882 3.23-1.335.058.028.094.082.147.117a.85.85 0 0 1 .808-.1c.442.18.654.683.471 1.123l-.072.173c-.438 1.052-.768 1.94-.386 2.168.005 0 .423.19.795.029.343-.154.627-.607.82-1.313.21-.778.077-1.488-.397-2.106-.675-.879-1.953-1.446-3.255-1.446-2.093 0-3.796 1.694-3.796 3.778 0 2.083 1.703 3.78 3.796 3.78.478 0 .865.385.865.86s-.387.86-.865.86C13.478 22 11 19.533 11 16.5s2.478-5.5 5.525-5.5c1.848 0 3.622.814 4.628 2.123zm-3.898 3.757c.413-.738.354-1.466-.141-1.72-.522-.267-1.274.129-1.637.776-.414.737-.35 1.545.14 1.806.491.26 1.224-.126 1.638-.863z"/><circle cx="9" cy="7" r="4"/></g></svg>'
      }
    });
  }

};

export default MentionIcon;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Icon/MentionIcon.js